import axios from 'axios';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Field, reduxForm } from 'redux-form';
import CustomerType from '../../component/CustomerType';
import { RenderSearchForm } from '../../component/formInput';
import Pagination from '../../component/Pagination';
import UserActiveStatus from '../../component/UserActiveStatus';
import { CustomerPageRole } from '../../component/UserPermission';
import CustomerTypeSelect from './components/CustomerTypeSelect';
import DateFilter from './components/DateFilter';

var moment = require('moment');
var _ = require('lodash');
var numeral = require('numeral');

function ActionDropdownMenu(data, rolePath, userProfile, onActiveUserLogin) {
  return (
    <React.Fragment>
      <td>
        <div className="icons-list">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              {/* 1. Chi Tiết */}
              <Link to={rolePath + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-list-numbered"></i> Chi tiết
              </Link>
              {/* 2. Nạp Tiền */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-add"></i> Nạp Tiền
              </Link> */}
              {/* 3. Trừ Tiền */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-subtract"></i> Trừ Tiền
              </Link> */}
              {/* 4. ATM */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-office"></i> ATM
              </Link> */}
              {/* 5. Nâng Cấp Đại Lý Cá Nhân */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-arrow-up-left32"></i> NC Đại Lý Cá Nhân
              </Link> */}
              {/* 6. Nâng Cấp Đại Lý Công Ty */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-arrow-up-right32"></i> NC Đại Lý Công Ty
              </Link> */}
              {/* 7. Tài Khoản Chính */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-cash3"></i> TK Chính
              </Link> */}
              {/* 8. Tài Khoản Khuyến Mãi */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-cash"></i> TK Khuyến Mãi
              </Link> */}
              {/* 9. Chuyển Giao Sale */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-user"></i> Chuyển Giao Sale
              </Link> */}
              {/* 10. Chuyển Giao Đại Lý */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-user-tie"></i> Chuyển Giao Đại Lý
              </Link> */}
              {/* 11. Đăng nhập id.tadu.cloud */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-enter3"></i> ID.TADU.CLOUD
              </Link> */}
              {/* 12. Đăng nhập Tách Khách Lẻ TADU */}
              {/* <Link to={role_path + "/customer/detail/"+ data.id} className="dropdown-item">
                <i className="icon-user-plus"></i> Tách Khách Lẻ TADU
              </Link> */}
              {/* 13. Kích hoạt tài khoản */}
              {!data.is_active && CustomerPageRole.isActiveAccount(userProfile.role) && <a onClick={()=>onActiveUserLogin(data.id)} className="dropdown-item">
                <i className="icon-checkmark4"></i> Kích hoạt tài khoản
              </a>}
            </div>
          </div>
        </div>
      </td>
    </React.Fragment>
  )
}

// Trạng thái đại lý.
// 1. Có phải Thương hiệu riêng hay không ?.
// 2. Có hỗ trợ ticket hay không ?.
function BooleanCheck(status) {
  let inner_html = <i style={{color: "green"}} className="icon-checkmark2"></i>
  if(!status) {
    inner_html = <i style={{color: "red"}} className="icon-cross3"></i>
  }
  return inner_html
}

class CustomerRows extends React.Component {
  render() {
    const { data, rolePath, onActiveUserLogin, userProfile } = this.props;
    const rows = _.map(data, function(i, index) {
      return (
        <tr key={index}>
          <td>
            {i.email}
            <br/>
            <small>{i.full_name}-{i.phone}</small>
          </td>
          <td>
            {i.primary_account ? numeral(i.primary_account.total).format("0,0") : 0}
            <br/>
            <small className="display-block text-muted text-size-small">
              {i.secoundary_account ? numeral(i.secoundary_account.total).format("0,0") : 0}
            </small>
          </td>
          <td>
            {i.sale ? i.sale.email : "N/A"}
            <br/>
            <small className="display-block text-muted text-size-small">
              {i.sale ? i.sale.full_name : "N/A"}
            </small>
          </td>
          <td>
            {CustomerType(i)}
          </td>
          <td style={{whiteSpace: 'nowrap'}}>
            {BooleanCheck(i.agency && i.agency.is_ticket)}
          </td>
          <td>
            {i.last_login ? moment(i.last_login).format("DD-MM-YYYY HH:mm:ss") : "N/A"}
          </td>
          <td>
            {i.last_order ? moment(i.last_order).format("DD-MM-YYYY HH:mm:ss") : "N/A"}
          </td>
          <td>
            {UserActiveStatus(i.is_active)}
          </td>
          {ActionDropdownMenu(i, rolePath, userProfile, onActiveUserLogin)}
        </tr>
      )
    })
    return rows;
  }
}

class CustomerTable extends React.Component {
  constructor(props) {
    const customer_type = new URLSearchParams(props.location.search).get("customer_type")
    const sort_by = new URLSearchParams(props.location.search).get("sort_by")
    super(props);
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        sort_asc: false,
        search_value: "",
        filter: sort_by ? sort_by : "all",
        customer_type: customer_type ? customer_type : "all",
        search_field: "search"
      }
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  listReload = (table_query) => {
    const self = this;

    axios({
      method: 'post',
      url: window.api_url + '/admin/api/customer/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }

  onSearchTxtChange = (event) => {
    const table_query = {
      ...this.state.table_query,
      search_value: event.target.value
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
  }

  onCustomerTypeSelect = (customer_type) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      customer_type: customer_type
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    this.listReload(table_query);
    history.push(
      role_path + "/customer?customer_type=" + customer_type + "&sort_by=" + table_query.filter
    );
  }

  onFilter = (filter_type) => {
    const { history, role_path } = this.props;
    const table_query = {
      ...this.state.table_query,
      filter: filter_type
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    this.listReload(table_query);
    history.push(
      role_path + "/customer?customer_type="+table_query.customer_type+"&sort_by=" + filter_type
    );

  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history, role_path } = this.props;
    
    const table_query = {
      ...this.state.table_query,
      current_page: 1,
      search_value: search_value,
      customer_type: "ALL",
      filter: "ALL"
    };
    history.push(role_path + "/customer?search=" + search_value);
    this.listReload(table_query);
  }

  clearDataFilter = () => {
    const { reset } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1,
      from_date: null,
      to_date: null
    };
    this.setState({
      ...this.state,
      table_query: table_query
    });
    reset();
    this.listReload(table_query);
  }
  
  onKeyPess = (key_code) => {
    const { history, role_path } = this.props;
    if (key_code == "Escape") {
      history.push(role_path + "/customer/all")
      this.clearDataFilter();
    }
  }

  // Kích hoạt tài khoản người dùng.
  onActiveUserLogin = (customer_id) => {
    const self = this;
    const { table_query } = this.state;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/customer/active',
      withCredentials: true,
      data: {
        customer_id: customer_id
      }
    }).then(function (response) {
      if(!response.data.isError) {
        self.listReload(table_query);
        toast.success("Kích hoạt tài khoản thành công.");
      }else {
        toast.error("Có lỗi trong quá trình kích hoạt tài khoản !");
      }
    });
  }

  render() {
    const { handleSubmit, role_path, userProfile } = this.props;
    const { table_query, table_data } = this.state;
    return(
      <React.Fragment>
        <ToastContainer />
        <div className="page-header">
          <div className="page-header-content header-elements-md-inline">
            <div className="page-title d-flex">
              <h4>
                <i className="icon-paragraph-justify2 mr-2"></i>
                <span className="text-semibold"> Danh Sách Khách Hàng</span>
              </h4>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Email khách hàng"
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="table-responsive">
                <div style={{margin:10}} className="text-align-right">
                  <CustomerTypeSelect customer_type_selected={table_query.customer_type} onCustomerTypeSelect={this.onCustomerTypeSelect}/>
                  <DateFilter filter_type_selected={table_query.filter} onFilter={this.onFilter}/>
                </div>
                <table className="table table-togglable table-hover">
                  <thead>
                    <tr>
                      <th data-toggle="true">
                        Email
                        <br/>
                        <small className="display-block text-muted text-size-small">Họ Tên - Điện Thoại</small>
                      </th>
                      <th style={{whiteSpace: 'nowrap'}} data-hide="phone">
                        TK Chính
                        <br/>
                        <small className="display-block text-muted text-size-small">TK Khuyến Mãi</small>
                      </th>
                      <th data-hide="phone">
                        Sale Man
                      </th>
                      <th data-hide="phone">
                        Loại
                      </th>
                      <th>
                        Ticket
                      </th>
                      <th data-hide="phone">
                        Last Login
                      </th>
                      <th data-hide="phone">
                        Last Order
                      </th>
                      <th data-hide="phone">
                        Trạng thái
                      </th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data.data && <CustomerRows data={table_data.data} userProfile={userProfile} rolePath={role_path} onActiveUserLogin={this.onActiveUserLogin} />}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
        </div>
      </React.Fragment>
    )
  }
}


const mapState = state => ({
  role_path: state.userProfile.role_path,
  userProfile: state.userProfile.data
});

const mapDispatch = (dispatch) => ({
});


const CustomerTableWrapper = reduxForm({
  form: 'CustomerTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(CustomerTable);

export default connect(mapState, mapDispatch)(withRouter(CustomerTableWrapper));
